import { getMonthToDateRange } from '@/utils/date';
import {
  parseActiveStatusFilter,
  parseNumberFilter,
  toActiveStatusFilterText,
  toFilterText,
  toGeoFilterValues,
  toGeoSearch,
  toPeriodFilterValues,
  toPeriodSearch,
} from '@/utils/filters';
import type { DcrDashboardSearch } from '../types/dashboard.types';

export function toDcrDashboardFilterValues(search: DcrDashboardSearch): Record<string, string> {
  return {
    ...toPeriodFilterValues(search, getMonthToDateRange()),
    isActive: toActiveStatusFilterText(search.isActive),
    reportingMemberId: toFilterText(search.reportingMemberId),
    companyId: toFilterText(search.companyId),
    departmentId: toFilterText(search.departmentId),
    ...toGeoFilterValues(search),
  };
}

export function toDcrDashboardFilterSearch(values: Record<string, string>): DcrDashboardSearch {
  return {
    ...toPeriodSearch(values),
    isActive: parseActiveStatusFilter(values.isActive),
    reportingMemberId: parseNumberFilter(values.reportingMemberId),
    companyId: parseNumberFilter(values.companyId),
    departmentId: parseNumberFilter(values.departmentId),
    ...toGeoSearch(values),
  };
}
